module.exports = __webpack_public_path__ + "8feeb84c56d104a93b3b3cf0949ace1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cloak-king.png
// module id = 1258
// module chunks = 0